import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import "./HomeSliderMobile.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import SwiperCore, {Navigation} from "swiper/core";

function HomeSliderMobile() {

    const history = useHistory();
    SwiperCore.use([Navigation]);

    return (
        <div className="home_slider_mobile">
            <div className="home_slider_pic_mobile">
                  <img src="./img/studio_display.webp" alt="" />
            </div>
            <div className="home_slider_text">
            <h1>
                Software für Ärzte seit 1986.
            </h1>
            <p>
                Premium Ordinationssoftware <br/>
                made in Austria.
            </p>
            <Link to="/" className="home-top-mobile-button">Beratungsgespräch buchen</Link>
            </div>
            
            {/* <div className="home_slider_slider_component">
        <h4>Unsere Produkte:</h4>
        <div className="home_slider_slider">
        <React.Fragment>
            <Swiper navigation={true} id="main" spaceBetween={110} slidesPerView={2}>
                 <SwiperSlide key={`slider-1`}>
                     <div className="slider_component" onClick={() => history.push("/eos")}>
                     <img src ="./img/Allgemeinmedizin_Icon.png" alt="Allgemeinmedizin"/>
                     <p>Komplettlösungen <br/> <span>  Algemeinmedizin</span></p>
                     </div>
               </SwiperSlide>
               <SwiperSlide key={`slider-1`}>
                     <div className="slider_component" onClick={() => history.push("/dental")}>
                     <img src ="./img/Zahnarzt_Icon.png" alt="Zahnarzt Programm"/>
                     <p>Komplettlösungen <br/> <span> Dental</span></p>
                     </div>
               </SwiperSlide>
               <SwiperSlide key={`slider-1`}>
                     <div className="slider_component" onClick={() => history.push("/eos")}>
                     <img src ="./img/Facharzt_Icon.png" alt="Computer-Programm-Facharzt"/>
                     <p>Komplettlösungen <br/> <span> Facharzt</span></p>
                     </div>
               </SwiperSlide>
               <SwiperSlide key={`slider-1`}>
                     <div className="slider_component" onClick={() => history.push("/termion")}>
                     <img src ="./img/Therapeut_Icon.png" alt="Therapeut-Software"/>
                     <p>Ordinationssoftware <br/> <span> Therapie & Alternativ</span></p>
                     </div>
               </SwiperSlide>
               <SwiperSlide key={`slider-1`}>
                     <div className="slider_component" onClick={() => history.push("/termion")}>
                     <img src ="./img/Buchungs_Icon.png" alt="Patienten-Buchung-Online"/>
                     <p>Online Buchung <br/> <span> für Ihre Patienten</span></p>
                     </div>
               </SwiperSlide>
               <SwiperSlide key={`slider-1`}>
                     <div className="slider_component" onClick={() => history.push("/eos")}>
                     <img src ="./img/Kalender_Icon.png" alt="Kalender-Für-Ärzte"/>
                     <p>Online-Terminkalender <br/> <span> für Ihre Ordination</span></p>
                     </div>
               </SwiperSlide>
               <SwiperSlide key={`slider-1`}>
                     <div className="slider_component" onClick={() => history.push("/eos")}>
                     <img src ="./img/Telemedizin_Icon.png" alt="Telemedizin-Ärzte"/>
                     <p>Telemedizin<br/> <span> Ihre Videosprechstunde</span></p>
                     </div>
               </SwiperSlide>
               <SwiperSlide key={`slider-1`}>
                     <div className="slider_component" onClick={() => history.push("/shop")}>
                     <img src ="./img/Zusatzmodule_Icon.png" alt="Zusatzmodule-Doctor" />
                     <p>Zusatzpakete<br/> <span> und Hardware</span></p>
                     </div>
               </SwiperSlide>
               <SwiperSlide key={`slider-1`}>
                     <div className="slider_end" >
                     </div>
               </SwiperSlide>
            </Swiper>
        </React.Fragment>
        </div>
            </div> */}
           
        </div>
    )
}

export default HomeSliderMobile
